import { Link } from "@tanstack/react-router";
import { useT } from "../providers/LocaleProvider";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

// Interim until backend password-reset (gap G7). See parity-inventory "Known stubs".
export function ForgotPasswordPage() {
    useDocumentTitle("Reset password");
    const t = useT();
    return (
        <main className="flex min-h-screen items-center justify-center p-8 font-sans">
            <div className="flex w-80 flex-col gap-3">
                <h1 className="text-xl">{t("forgot.title")}</h1>
                <p>{t("forgot.hint")}</p>
                <Link to="/auth/login" className="underline">
                    {t("login.title")}
                </Link>
            </div>
        </main>
    );
}
